export default "__VITE_ASSET__m3aVa4sn__"